import React from "react";
import { Building2 } from "lucide-react";
import { Reveal } from "../Reveal";
import { trustedBrands } from "../../mock";

const BrandPill = ({ name }) => (
  <div className="flex shrink-0 items-center gap-2.5 rounded-xl border border-white/10 bg-white/[0.03] px-5 py-3 transition-colors duration-300 hover:border-cyan-400/30 hover:bg-cyan-400/[0.04]">
    <Building2 className="h-4 w-4 shrink-0 text-cyan-300/80" />
    <span className="font-display whitespace-nowrap text-sm font-semibold text-slate-300">{name}</span>
  </div>
);

const TrustedBy = () => (
  <section className="relative py-16 lg:py-20">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal>
        <p className="text-center text-xs font-medium uppercase tracking-[0.22em] text-slate-500">
          Trusted by leading hospital brands
        </p>
      </Reveal>

      <Reveal delay={120}>
        <div className="relative mt-9 overflow-hidden">
          {/* edge fades */}
          <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-[#04060a] to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-[#04060a] to-transparent" />
          <div className="marquee-track flex w-max items-center gap-4">
            {[...trustedBrands, ...trustedBrands].map((b, i) => (
              <BrandPill key={`${b}-${i}`} name={b} />
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default TrustedBy;
